/* ScheduleDaySlider.jsx */
import React, { useContext, useRef, Fragment } from 'react'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { Box, Typography, Stack, IconButton } from '@mui/material'
import { useDraggable } from 'react-use-draggable-scroll'
import { CircleDate } from '../../Simple'
import { useScheduleDaySlider } from './ScheduleDaySlider.functions'
import { EmpresasContext } from '../../../contexts/EmpresasContext'

export default function ScheduleDaySlider() {
  const { sttPg } = useContext(EmpresasContext)

  const cursorRef = useRef()
  const { events } = useDraggable(cursorRef)
  const centerDateRef = useRef(null)

  const {
    sttCmp,
    selectDay,
    handleNext,
    handlePrevious,
    getMonthHeader,
    verificaDesativarGrade,
    verificaMaximoDias,
  } = useScheduleDaySlider(cursorRef, centerDateRef)

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {/* Cabeçalho do mês */}
      <Typography align='center' fontWeight='bold' fontFamily='Jost' variant='body1'>
        {getMonthHeader()}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          mt: 1,
        }}
      >
        {/* Botão “Previous” */}
        <IconButton onClick={handlePrevious} disabled={sttCmp.disabledPrevious}>
          <IoIosArrowBack size='24px' color={sttCmp.disabledPrevious ? '#FAE6D8' : '#FF7043'} />
        </IconButton>

        {/* Carrossel de dias */}
        <Stack
          direction='row'
          spacing={1}
          sx={{
            display: 'flex',
            overflowX: 'auto',
            cursor: 'grab',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': { display: 'none' },
            gap: 1,
            p: 1,
          }}
          {...events}
          ref={cursorRef}
        >
          {sttCmp.arrayDias.map(dia => (
            <Fragment key={dia.format('YYYY-MM-DD')}>
              {/* “Marcador” para o primeiro item visível (IntersectionObserver) */}
              {sttCmp.arrayDias.indexOf(dia) === 2 && (
                <Box id='firstItem' sx={{ width: 4, height: 4 }} />
              )}

              <CircleDate
                dia={dia}
                onClick={() => selectDay(dia)}
                disabled={verificaDesativarGrade(dia) || verificaMaximoDias(dia)}
                ref={dia.isSame(sttCmp.dataCenter, 'day') ? centerDateRef : null}
                selected={dia.isSame(sttPg.selectedDay, 'day')}
              />
            </Fragment>
          ))}

          {/* “Marcador” para fim do carrossel (infinite scroll) */}
          <Box id='lastItem' sx={{ width: 4, height: 4 }} />
        </Stack>

        {/* Botão “Next” */}
        <IconButton onClick={handleNext} sx={{ ml: 1 }}>
          <IoIosArrowForward size='24px' color='#FF7043' />
        </IconButton>
      </Box>
    </Box>
  )
}
